import { NavLink } from "react-router-dom";
import type { Household } from "../../shared/types";
import { WalletIcon, SignOutIcon } from "./icons";
import { NAV } from "../lib/nav";

/** Dark navigation rail (desktop) / bottom tab bar (mobile) from the designs. */
export default function Sidebar({
  household,
  me,
  onLogout,
}: {
  household?: Household;
  me?: string;
  onLogout?: () => void;
}) {
  const memberNames = household?.members.map((m) => m.name).join(" & ");

  return (
    <nav className="sidebar" aria-label="Primary">
      <div className="sidebar__brand">
        <div className="sidebar__logo" aria-hidden="true">
          <WalletIcon width={20} height={20} style={{ color: "#fff" }} strokeWidth={1.8} />
        </div>
        <div className="sidebar__brand-text">
          <span className="sidebar__brand-name">Expense Tracker</span>
          <span className="sidebar__brand-sub">{household?.name ?? "Your tracker"}</span>
        </div>
      </div>

      <ul className="sidebar__nav">
        {NAV.map(({ to, label, Icon, end, secondary }) => (
          <li key={to} className={secondary ? "sidebar__navitem--secondary" : undefined}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                "sidebar__link" + (isActive ? " is-active" : "")
              }
            >
              <Icon className="sidebar__icon" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="sidebar__footer">
        <div className="sidebar__footer-text">
          <span className="sidebar__footer-primary">{me ?? memberNames ?? " "}</span>
          <span className="sidebar__footer-sub">{me ? "Signed in" : "Personal finances"}</span>
        </div>
        {onLogout && (
          <button type="button" className="sidebar__signout" onClick={onLogout} title="Sign out" aria-label="Sign out">
            <SignOutIcon className="sidebar__icon" />
            <span>Sign out</span>
          </button>
        )}
      </div>
    </nav>
  );
}
